import { BaseService } from "../base.service";

export class KandjiService extends BaseService {
  constructor() {
    super();
  }

  async syncDevices() {
    const resp = await this.client.post(
      "/company/integration/kandji/sync",
      {}
    );

    return resp?.data;
  }
}

export const kandjiService = new KandjiService();
